export default __webpack_public_path__ + "static/media/techspec.3b34aad0.png";